import { DcrKeyValue } from '@ddt-web/config';

export interface InvestmentProcessStep {
	header: DcrKeyValue;
	description: DcrKeyValue;
}


// the models type string would be appended to each dcr keys to make it more specific to the models
export const investmentProcessSteps: InvestmentProcessStep[] = [
	{
		header: {
			dcrKey: 'INVESTMENT_PROCESS_STEP1_HEADER',
			dcrValue: 'Set your risk Composition'
		},
		description: {
			dcrKey: 'INVESTMENT_PROCESS_STEP1_DESC',
			dcrValue: `Determine desired total portfolio risk level relative to market views and benchmarks. 
			Seek appropriate diversification across risk factors and mitigate uncompensated risks.`
		}
	},
	{
		header: {
			dcrKey: 'INVESTMENT_PROCESS_STEP2_HEADER',
			dcrValue: 'Asset class Selection'
		},
		description: {
			dcrKey: 'INVESTMENT_PROCESS_STEP2_DESC',
			dcrValue: `Allocate capital across 10+ asset classes (US, Int’l and EM stocks, REITs, MLPs, Municipal Bonds, 
				Sovereign Debt, Investment Grade, High Yield, Preferred Stock, MBS, EM Debt)`
		}
	},
	{
		header: {
			dcrKey: 'INVESTMENT_PROCESS_STEP3_HEADER',
			dcrValue: 'Investment vehicle selection'
		},
		description: {
			dcrKey: 'INVESTMENT_PROCESS_STEP3_DESC',
			dcrValue: `Select appropriate investment vehicles that are efficient, cost­ effective, and accurately express targeted exposures across both active 
			and passive vehicles to diversify sources of return.`
		}
	},
	{
		header: {
			dcrKey: 'INVESTMENT_PROCESS_STEP4_HEADER',
			dcrValue: 'Monitor and adapt'
		},
		description: {
			dcrKey: 'INVESTMENT_PROCESS_STEP4_DESC',
			dcrValue: `Monitor and change exposures as necessary across and within asset classes to seek attractive risk-adjusted return. 
			Adjust portfolios to changing macroeconomic and market conditions/risks; typically 2-4 trades per year`
		}
	}
];
